import { PropsWithChildren } from "react";

import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { ChevronLeft } from "@/assets/icons/24/ChevronLeft";
import { AccountSettingsViewProps } from "@/common/contracts/account.contracts";
import { Heading } from "@/ui/cva/Heading";
import { Body } from "@/ui/typography/Body";

export const AccountSettingsWrapper = ({
  children,
  title,
}: PropsWithChildren<AccountSettingsViewProps>) => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <div className="flex w-full flex-col gap-6 pb-10 md:pl-6">
      <span className="flex flex-col space-y-3 md:space-y-0">
        <button
          onClick={() => router.back()}
          className="flex items-center space-x-3 self-start text-grey-500 md:hidden"
        >
          <ChevronLeft className="h-4 w-4" />
          <Body className="text-gray-500">
            {t("account:your-account-account-title")}
          </Body>
        </button>
        <button
          type="button"
          className="flex items-center space-x-2"
          onClick={() => router.back()}
        >
          <ChevronLeft className="h-6 w-6" />
          <Heading as="h1" size="h4">
            {t(title)}
          </Heading>
        </button>
      </span>
      {children}
    </div>
  );
};
